// billingAndRewards.ts

import api from "@/services/api";
import type {
  ApplyPromoFilters,
  PromoAppliedResponse,
  VoucherResponse,
  ReferrerDashboardResponse,
  ProfileSubscriptionResponse,
  ReferralLogItem,
} from "../types/BillingAndRewards.dto.types";

const billingAndRewardsApi = {
  applyPromoCode: async ({ code, currentOrderSubtotal }: ApplyPromoFilters): Promise<PromoAppliedResponse> => {
    const response = await api.post<PromoAppliedResponse>(`/promotions/apply`, {
      code,
      currentOrderSubtotal,
    });
    return response.data;
  },

  getMyVouchers: async (): Promise<VoucherResponse[]> => {
    const response = await api.get<VoucherResponse[]>(`/promotions/my-vouchers`);
    return response.data;
  },

  getReferralDashboard: async (): Promise<ReferrerDashboardResponse> => {
    const response = await api.get<ReferrerDashboardResponse>(`/referrals/my-dashboard`);
    return response.data;
  },

  getReferralHistory: async (): Promise<ReferralLogItem[]> => {
    const response = await api.get<ReferralLogItem[]>(`/referrals/referral-history`);
    return response.data;
  },

  getSubscriptionProfile: async (): Promise<ProfileSubscriptionResponse> => {
    const response = await api.get<ProfileSubscriptionResponse>(`/subscription/subscription-profile`);
    return response.data;
  },
};

export default billingAndRewardsApi;
